import { useProcess, useSelect } from '~/store'
import {
  ClientLoginFlowMessage,
  ClientLoginFlowState,
  clientLoginFlowModule
} from './client-login-flow-module'

export function useClientLoginFlow(): {
  state: ClientLoginFlowState | null
  send: (message: ClientLoginFlowMessage) => void
} {
  const flow = useProcess('clientLoginFlow')
  const state = useSelect('clientLoginFlow', (s) => s)

  return {
    state: state,
    send: flow.send
  }
}
